const tabArray = ["All", "Business Directory", "Contact Directory", "Marketplace", "Site Content", "Industry"] as const;

export type Tab = typeof tabArray[number];

export const stringToTab = (string: string): Tab | undefined => {
  const tabOrUndefined = tabArray.find((ta) => ta === string);

  return tabOrUndefined ? tabOrUndefined : void 0;
};


interface TabContentsComponentProps {
  "activeTab": Tab;
  "companyProfilesSearchValue": string;
  "countryCode"?: string | null | undefined;
  "env": string | null | undefined;
  "isBusinessDirectoryLandingPageOrContactDirectoryLandingPageOrErrorPage": boolean;
  "isEuBd"?: boolean;
  "isSearchOverlay": boolean;
  "isSearchOverlayAndNotUnitedStates": boolean;
  "isSearchOverlayOpen": boolean;
  "isSiteSearchResultsPage": boolean;
  "manuallyTriggerNavigation": () => void;
  "resourcePath": string | undefined;
  "searchInput": string;
  "setActiveTab": (tab: Tab) => void;
  "setCompanyProfilesSearchValue": (newValue: string) => void;
  // "setIsSearchOverlayOpen": Dispatch<SetStateAction<boolean>> | undefined;
  "setSearchInput": (string: string) => void;
  // "singlePageSearchData": SinglePageSearchData;
  "tabAllSearchValue"?: string | undefined;
  "token": string;
  "useFragmentAndUrlState": (key: string, defaultValue: string) => [string, (value: string) => void];
  "useFragmentAndUrlStateTriggerNavigation": (key: string, defaultValue: string, outerTriggerNavigation: boolean) => [string, (newValue: string) => void];
}

export type TabContentsComponent = (properties: TabContentsComponentProps) => JSX.Element;

export const getPageNumberFragmentParameterName = (tab: Tab): string => `${tab.replace(" ", "").replace("&", "And")}PageNumber`;

export const getSearchFragmentParameterName = (tab: Tab): string => `${tab.replace(" ", "").replace("&", "And")}Search`;

export const contactProfilesCompanyFragmentParameterName = "ContactProfilesCompany";
export const contactProfilesFullNameFragmentParameterName = "ContactProfilesFullName";
export const contactProfilesJobTitleFragmentParameterName = "ContactProfilesJobTitle";

 
